var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('icon-base',{attrs:{"height":_vm.height,"width":_vm.width,"styles":_vm.styles,"view-box":"0 0 44 44"}},[_c('circle',{staticClass:"path2",attrs:{"cx":"22","cy":"22","r":"20","fill":"none","stroke-width":"4"}}),_vm._v(" "),_c('circle',{staticClass:"path",attrs:{"cx":"22","cy":"22","r":"20","fill":"none","stroke-width":"4"}})])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-05f6a56e","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/icons/SpinnerIcon.vue
// module id = null
// module chunks = 